import { NodeConverters, notImplemented } from "../_namespaces/lpc";

/** @internal */
export const nullNodeConverters: NodeConverters = {
    convertToFunctionBlock: notImplemented,
    convertToFunctionExpression: notImplemented,
    //convertToClassExpression: notImplemented,
    // convertToArrayAssignmentElement: notImplemented,
    // convertToObjectAssignmentElement: notImplemented,
    // convertToAssignmentPattern: notImplemented,
    // convertToObjectAssignmentPattern: notImplemented,
    // convertToArrayAssignmentPattern: notImplemented,
    // convertToAssignmentElementTarget: notImplemented,
};
